module.exports = __webpack_public_path__ + "static/media/Frame 3000.6a02e057.svg";